import React, { Fragment, useState } from 'react';
import { Container } from 'react-bootstrap';
import HeaderLogged from '../../../../components/header_logged'
import Footer from '../../../../components/footer'
import Head from '../../../../components/head';
import Objeto from '../../../../components/auth/licitacao/listar/form_objeto'


function ObjetoLicScreen() {

    return (
        <Fragment>
            <Head titulo="Editando Objeto" />
            <HeaderLogged />
            <Container>
               <Objeto />
            </Container>
            <Footer />
        </Fragment>
    );
}

export default ObjetoLicScreen;